import { Routes } from "@angular/router";
import {routeNames} from "../../shared/route-names";
import {UsersManagementComponent} from "./components/users-management/users-management.component";
import {TranslationsAdminComponent} from "./components/translations-admin/translations-admin.component";
import {SitesManagementComponent} from "./components/sites-management/sites-management.component";
import {AdminGuard} from "../shared/guards/admin.guard";


export const administrationRoutes: Routes = [
    {
        path: routeNames.userManagement,
        data: { title: "general.navigation.users-management" },
        component: UsersManagementComponent,
        canActivate: [],
    },
    {
        path: routeNames.translations,
        data: { title: "general.navigation.translations" },
        component: TranslationsAdminComponent,
        canActivate: [AdminGuard],
        canMatch: [AdminGuard]
    },
    {
        path: routeNames.sitesManagement,
        data: { title: "pages.sites_management.navigation.title" },
        component: SitesManagementComponent,
        canActivate: [AdminGuard],
        canMatch: [AdminGuard]
    },
    {
        path: `${routeNames.equipmentImport}/:siteId`,
        loadComponent: () => import('./components/equipment-import/pages/import-page/import-page.component')
            .then(m => m.ImportPageComponent),
        canActivate: [AdminGuard],
        canMatch: [AdminGuard]
    }
];
